var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { name: "privacy-settings" } },
    [
      _c("div", { staticClass: "ui two column stackable grid" }, [
        _c("div", { staticClass: "eight wide column" }, [
          _c("div", { staticClass: "ui segment" }, [
            _c("div", { staticClass: "ui header" }, [
              _vm._v("Ny EU persondataforordning - GDPR")
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Derudover kan forhandleren du har et abonnement hos, vælge at gemme andre informationer som gør at forhandleren kan levere ydelsen til dig."
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Ifølge den nye persondata lov bestemmer du selv hvem du deler dine informationer med og hvad de bruges til. Zietwing giver dig mulighed for at udøve din ret til indsigt omkring hvilke oplysninger forhandleren gemmer om dig."
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Ønsker du ikke at beholde dine data i Zietwing kan du anmode om at blive glemt. Dine data vil så blive slettet/ anonymiseret i Zietwing og du vil ikke længere kunne modtage ydelsen fra dine forhandlere eller tilgå din brugerprofil."
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(" Læs i øvrigt Zietwings "),
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.openTerms()
                    }
                  }
                },
                [_vm._v("handelsbetingelser, cookies- og privatlivspolitikker")]
              ),
              _vm._v(
                " hvis du gerne vil vide mere omkring hvordan vi løbende arbejder på at sikre dine informationer."
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "eight wide column" }, [
          _c("div", { staticClass: "ui form" }, [
            _c("div", { staticClass: "field" }, [
              _c(
                "div",
                {
                  staticClass: "ui red button",
                  on: {
                    click: function($event) {
                      _vm.showUserdataNotice = !_vm.showUserdataNotice
                    }
                  }
                },
                [
                  _vm._v(
                    "\n\t\t\t\t\t\t\t" +
                      _vm._s(
                        _vm.$t("pages.profile.settings.privacy.userdata.button")
                      ) +
                      "\n\t\t\t\t\t\t"
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ui segment" }, [
              _c("b", [
                _vm._v(
                  _vm._s(
                    _vm.$t("pages.profile.settings.privacy.userdata.header")
                  )
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n\t\t\t\t\t\t\t" +
                    _vm._s(
                      _vm.$t("pages.profile.settings.privacy.userdata.body")
                    ) +
                    "\n\t\t\t\t\t\t"
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "field" }, [
              _c(
                "div",
                {
                  staticClass: "ui red button",
                  on: {
                    click: function($event) {
                      _vm.showForgottenNotice = !_vm.showForgottenNotice
                    }
                  }
                },
                [
                  _vm._v(
                    "\n\t\t\t\t\t\t\t" +
                      _vm._s(
                        _vm.$t(
                          "pages.profile.settings.privacy.forgotten.button"
                        )
                      ) +
                      "\n\t\t\t\t\t\t"
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ui segment" }, [
              _c("b", [
                _vm._v(
                  _vm._s(
                    _vm.$t("pages.profile.settings.privacy.forgotten.header")
                  )
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n\t\t\t\t\t\t\t" +
                    _vm._s(
                      _vm.$t("pages.profile.settings.privacy.forgotten.body")
                    ) +
                    "\n\t\t\t\t\t\t"
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "forgottenmodal",
          attrs: {
            active: _vm.showForgottenNotice,
            title: _vm.$t(
              "pages.profile.settings.privacy.forgotten.modal.title"
            ),
            icons: "big times circle outline"
          },
          on: {
            acceptmodal: function($event) {
              return _vm.requestForgotten()
            }
          }
        },
        [
          _c("h3", [
            _vm._v(
              _vm._s(
                _vm.$t("pages.profile.settings.privacy.forgotten.modal.header")
              )
            )
          ]),
          _vm._v(" "),
          _c("span", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("pages.profile.settings.privacy.forgotten.modal.body")
              )
            }
          }),
          _vm._v(" "),
          _c("div", { attrs: { slot: "box-actions" }, slot: "box-actions" }, [
            _c(
              "div",
              {
                staticClass: "ui basic circular red button",
                on: {
                  click: function($event) {
                    return _vm.$refs.forgottenmodal.denyModal()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("globals.buttons.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "ui blue circular button",
                on: {
                  click: function($event) {
                    return _vm.$refs.forgottenmodal.acceptModal()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("globals.buttons.accept")))]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "userdatamodal",
          attrs: {
            active: _vm.showUserdataNotice,
            title: _vm.$t(
              "pages.profile.settings.privacy.userdata.modal.title"
            ),
            icons: "big user circle"
          },
          on: {
            acceptmodal: function($event) {
              return _vm.requestUserData()
            }
          }
        },
        [
          _c("h3", [
            _vm._v(
              _vm._s(
                _vm.$t("pages.profile.settings.privacy.userdata.modal.header")
              )
            )
          ]),
          _vm._v(" "),
          _c("span", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("pages.profile.settings.privacy.userdata.modal.body")
              )
            }
          }),
          _vm._v(" "),
          _c("div", { attrs: { slot: "box-actions" }, slot: "box-actions" }, [
            _c(
              "div",
              {
                staticClass: "ui basic circular red button",
                on: {
                  click: function($event) {
                    return _vm.$refs.userdatamodal.denyModal()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("globals.buttons.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "ui blue circular button",
                on: {
                  click: function($event) {
                    return _vm.$refs.userdatamodal.acceptModal()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("globals.buttons.accept")))]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n\t\t\t\t\t\tZietwing passer godt på dine oplysninger og overholder de nye EU regler for datahåndtering. Vi gemmer kun de data som er nødvendige for at kunne give dig en god brugeroplevelse.\n\t\t\t\t\t\tEksempler på typer af data som gemmes i Zietwing:\n\t\t\t\t\t\t"
      ),
      _c("ul", [
        _c("li", [_vm._v("Oplysninger du selv har gemt")]),
        _vm._v(" "),
        _c("li", [_vm._v("Krypteret betalingsidentitet")]),
        _vm._v(" "),
        _c("li", [_vm._v("Betalingshistorik")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a720d1a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a720d1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/profile/PrivacySettings.vue
// module id = 8AlU
// module chunks = 1